import React from "react";

export default function BooleanEditor(props) {
	return <div></div>;
}
